"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertNodeToReactElement = void 0;
const domelementtype_1 = require("domelementtype");
const ProcessTextNode_1 = require("./elementTypes/ProcessTextNode");
const ProcessTagNode_1 = require("./elementTypes/ProcessTagNode");
const ProcessStyleNode_1 = require("./elementTypes/ProcessStyleNode");
function convertNodeToReactElement(node, index, transform) {
    switch (node.type) {
        case domelementtype_1.ElementType.Text:
            return (0, ProcessTextNode_1.processTextNode)(node);
        case domelementtype_1.ElementType.Tag:
            return (0, ProcessTagNode_1.processTagNode)(node, index, transform);
        case domelementtype_1.ElementType.Style:
            return (0, ProcessStyleNode_1.processStyleNode)(node, index);
        default:
            return null;
    }
}
exports.convertNodeToReactElement = convertNodeToReactElement;
